/**
 * Login.js - Scripts específicos para páginas de login
 * Contém apenas funcionalidades necessárias para autenticação
 */

// jQuery
window.$ = window.jQuery = require("jquery");
require("jquery-mask-plugin");

// Utilitários básicos necessários
import { setLoadingState, resetButtonState } from './utils/common.js';

$(document).ready(function () {
    // Inicializar apenas funcionalidades de login
    initLoginGarage();
    initLoginBackoffice();
    initForgotPassword();
    
    // Aplicar máscaras básicas se necessário
    aplicarMascarasBasicas();
});

/**
 * Inicializa validação e carregamento do login da garage
 */
function initLoginGarage() {
    $(".btn-loginGarage").on("click", function (e) {
        let user = $("#emailUser");
        let pass = $("#passUser");

        if (pass.val() !== "" && pass.val().length >= 8) {
            $(this).html(
                `<i class="sg sg-spinner-gap animate-spin"></i> Entrando...`
            );

            setTimeout(() => {
                $(".form-loginGarage").trigger("submit");
            }, 2000);
        }
    });
}

/**
 * Inicializa validação e carregamento do login do backoffice
 */
function initLoginBackoffice() {
    $(".btn-loginBackoffice").on("click", function (e) {
        e.preventDefault();
        let user = $("#userBackoffice");
        let pass = $("#passBackoffice");

        if (user.val() !== "") {
            if (pass.val().length < 8) {
                alert("A senha deve ter, no mínimo, 8 caracteres!");
                pass.trigger("focus");
                return false;
            } else if (pass.val() !== "" && pass.val().length >= 8) {
                $(this).html(
                    `<i class="sg sg-spinner-gap animate-spin"></i> Entrando...`
                );

                setTimeout(() => {
                    $(".form-loginBackoffice").trigger("submit");
                }, 2000);
            } else {
                alert("Senha não pode ser vazia!");
                pass.trigger("focus");
                return false;
            }
        } else {
            alert("Informe o e-mail!");
            user.trigger("focus");
            return false;
        }
    });
}

/**
 * Inicializa funcionalidade de esqueci minha senha
 */
function initForgotPassword() {
    // Toggle entre login e forgot password com animação de slide
    $(document).on("click", ".forgotPass", function (e) {
        e.preventDefault();
        const forgot = $(".forgot-content");
        if (forgot.hasClass("d-none")) {
            forgot.removeClass("d-none");
            $("body").addClass("forgotActive");
        } else {
            $("body").removeClass("forgotActive");
            // aguarda a animação terminar antes de ocultar
            setTimeout(() => {
                forgot.addClass("d-none");
            }, 300);
        }
    });

    // Submissão do formulário de esqueci senha
    $("#forgotPasswordForm").on("submit", function (e) {
        e.preventDefault();
        const button = $("#forgotPasswordButton");
        const originalText = button.text();
        setLoadingState(button[0], "Enviando...");
        $("#error-email").text("");

        $.ajax({
            url: $(this).attr("action"),
            method: "POST",
            data: {
                email: $("#emailForgot").val(),
                _token: $('meta[name="csrf-token"]').attr('content')
            },
            success: function (resp) {
                resetButtonState(button[0]);
                if (resp && resp.success) {
                    const modalEl = document.getElementById('modalForgotPass');
                    if (modalEl) {
                        new bootstrap.Modal(modalEl).show();
                    }
                } else if (resp && resp.errors && resp.errors.email) {
                    $("#error-email").text(resp.errors.email[0]);
                } else {
                    $("#error-email").text("Não foi possível enviar. Tente novamente.");
                }
            },
            error: function () {
                resetButtonState(button[0]);
                $("#error-email").text("Erro ao enviar. Tente novamente.");
            }
        });
    });
}

/**
 * Aplica máscaras básicas necessárias para login
 */
function aplicarMascarasBasicas() {
    // Aplicar máscara de email se necessário
    $('input[type="email"]').on('blur', function() {
        const email = $(this).val();
        if (email && !isValidEmail(email)) {
            $(this).addClass('is-invalid');
        } else {
            $(this).removeClass('is-invalid');
        }
    });
}

/**
 * Valida formato de email
 */
function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

// Status loading button - funcionalidade global para login
document.addEventListener("DOMContentLoaded", function () {
    document.body.addEventListener("click", function (event) {
        const target = event.target;

        if (target.matches("button[data-loading-text], input[type='submit'][data-loading-text]")) {
            const loadingText = target.getAttribute("data-loading-text");

            if (loadingText && target.closest("form")) {
                const form = target.closest("form");

                // Verifica se o formulário é válido antes de enviar
                if (!form.checkValidity()) {
                    form.classList.add("was-validated");
                    return;
                }

                event.preventDefault();
                setLoadingState(target, loadingText);

                setTimeout(() => {
                    form.submit();
                }, 1000);
            }
        }
    });
});